/**
 * Mapa provozovny (kontakty) i mapový blok z content builderu.
 *
 * Proč Leaflet a ne vložený rámec z openstreetmap.org: bezpečnostní hlavička
 * webu (Content-Security-Policy v boot.php) pouští cizí zdroje jen pro dlaždice
 * OSM (`img-src ... *.tile.openstreetmap.org`). Iframe by prohlížeč zablokoval,
 * kdežto Leaflet běží z našeho serveru a stahuje jen ty dlaždice.
 *
 * Knihovna se načítá až když je mapa na stránce, takže ostatní stránky
 * nestahují nic navíc.
 *
 * Přístupnost: mapa je jen doplněk, adresa je vždycky i textem vedle (WCAG 1.1.1).
 * Scroll kolečkem je vypnutý, dokud do mapy uživatel neklikne – jinak by se
 * při rolování stránky nedalo mapu „přejet" (WCAG 2.5.7 / běžná UX past).
 */

const LEAFLET_CSS = '/www/assets/vendor/leaflet/leaflet.min.css';
const LEAFLET_JS  = '/www/assets/vendor/leaflet/leaflet.min.js';
const ICON_PATH   = '/www/assets/vendor/leaflet/images';

let leafletPromise = null;

function loadLeaflet() {
    if (window.L) return Promise.resolve(window.L);
    if (leafletPromise) return leafletPromise;

    leafletPromise = new Promise((resolve, reject) => {
        if (!document.querySelector('link[data-leaflet]')) {
            const link = document.createElement('link');
            link.rel = 'stylesheet';
            link.href = LEAFLET_CSS;
            link.dataset.leaflet = '';
            document.head.appendChild(link);
        }

        const script = document.createElement('script');
        script.src = LEAFLET_JS;
        script.onload = () => {
            // Při dynamickém načtení si Leaflet cestu k ikonám markeru neodvodí sám.
            delete window.L.Icon.Default.prototype._getIconUrl;
            window.L.Icon.Default.mergeOptions({
                iconUrl:       `${ICON_PATH}/marker-icon.png`,
                iconRetinaUrl: `${ICON_PATH}/marker-icon-2x.png`,
                shadowUrl:     `${ICON_PATH}/marker-shadow.png`,
            });
            resolve(window.L);
        };
        script.onerror = () => reject(new Error('Leaflet se nepodařilo načíst'));
        document.head.appendChild(script);
    });

    return leafletPromise;
}

async function initMap(el) {
    if (el.dataset.mapReady === '1') return;
    el.dataset.mapReady = '1';

    const lat = parseFloat(el.dataset.lat);
    const lon = parseFloat(el.dataset.lon);
    if (!Number.isFinite(lat) || !Number.isFinite(lon)) return;

    const zoom  = parseInt(el.dataset.zoom || '14', 10);
    const label = el.dataset.label || '';

    let L;
    try {
        L = await loadLeaflet();
    } catch (e) {
        return; // bez knihovny zůstane vidět textový odkaz pod mapou
    }

    const map = L.map(el, {
        scrollWheelZoom: false,   // zapne se až po kliknutí do mapy
        attributionControl: true,
    }).setView([lat, lon], zoom);

    // Světlá podkladová vrstva: standardní OSM ztlumená filtrem v CSS.
    // Jiného poskytovatele dlaždic nepustí bezpečnostní hlavička.
    L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
        maxZoom: 19,
        attribution: '&copy; přispěvatelé <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>',
    }).addTo(map);

    const marker = L.marker([lat, lon], { title: label, keyboard: true }).addTo(map);
    if (label) marker.bindPopup(label);

    map.on('click', () => map.scrollWheelZoom.enable());
    map.on('mouseout', () => map.scrollWheelZoom.disable());

    // Mapa schovaná v neaktivní části stránky má nulovou výšku – přepočítat.
    setTimeout(() => map.invalidateSize(), 100);
}

function init() {
    document.querySelectorAll('[data-map]').forEach(initMap);
}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
} else {
    init();
}
